import { useEffect } from 'react';

const STYLE_ID = 'puzzel-custom-styles';
const company = import.meta.env.VITE_AUTH_REALM || '';

const WHITE = '#ffffff';

const getPuzzelChatStyles = (): string | null => {
	if (company === 'Motorcade') {
		const PRIMARY = '#2C3340';
		return `[data-puzzel-chat]{z-index:999999;& .controls-0-0-9{color:${PRIMARY};& .puzzel-chat-1-6-21-right .puzzel-chat-1-6-21-button .puzzel-chat-1-6-21-icon{stroke:${PRIMARY}}}& .startBubble-0-0-1{& span{color:${PRIMARY}}& .icon{fill:${PRIMARY}}&:hover span{color:${WHITE}; fill:${WHITE}}}}`;
	}
	return null;
};

const CSS = getPuzzelChatStyles();

const PuzzelChatWidget: React.FC = () => {
	useEffect(() => {
		const loader = document.createElement('script');
		let style: HTMLStyleElement | null = null;
		loader.src = 'https://euwa.puzzel.com/loader/index.js';
		loader.async = true;
		document.body.appendChild(loader);

		loader.onload = () => {
			if (window.EUWALoader) {
				new window.EUWALoader({
					customerKey: import.meta.env.VITE_PUZZEL_CUSTOMER_KEY,
					configId: import.meta.env.VITE_PUZZEL_CONFIG_ID,
				}).load();

				if (!document.getElementById(STYLE_ID) && CSS) {
					style = document.createElement('style');
					style.id = STYLE_ID;
					style.textContent = CSS;
					document.head.appendChild(style);
				}
			}
		};

		return () => {
			loader.remove();
			style?.remove();
		};
	}, []);

	return null; // This widget only injects the script, no visible UI
};

const PuzzelWidget = () => {
	if (!import.meta.env.VITE_USE_PUZZEL_CHAT || import.meta.env.VITE_USE_PUZZEL_CHAT !== 'true') return null;
	return <PuzzelChatWidget />;
};

export default PuzzelWidget;
